// eslint-disable-next-line import/no-unresolved
module.exports = require('./lib');



/*****************
 ** WEBPACK FOOTER
 ** ./~/react-dates/index.js
 ** module id = 22
 ** module chunks = 0
 **/